import { type ChangeEvent, type FC, type InputHTMLAttributes, useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';

import cn from 'classnames';

import styles from './PhoneInputWithoutCode.module.scss';

interface PhoneInputProps extends InputHTMLAttributes<HTMLInputElement> {
	disabledSelect?: boolean;
	noValidate?: boolean;
	value?: string;
	sizeType?: 'large' | 'middle';
}

export const PhoneInputWithoutCode: FC<PhoneInputProps> = ({
	name,
	disabledSelect,
	value: externalValue,
	onChange,
	sizeType = 'middle',
	...props
}) => {
	const [maskedValue, setMaskedValue] = useState(externalValue);

	useEffect(() => {
		if (externalValue !== maskedValue) {
			setMaskedValue(externalValue);
		}
	}, [externalValue, maskedValue]);

	return (
		<IMaskInput
			{...props}
			value={maskedValue}
			className={cn(styles.phoneInput, {
				[styles.large]: sizeType === 'large',
				[styles.middle]: sizeType === 'middle',
				[styles.placeholderColor]: maskedValue == '',
			})}
			onAccept={(value) => {
				onChange?.({
					target: { value: `${value}` },
				} as ChangeEvent<HTMLInputElement>);
				setMaskedValue(value);
			}}
			unmask
			lazy={false}
			mask="+0 (000) 000-00-00"
		/>
	);
};
